<script setup>
import SportLiveTvAlertIcon from '@/sport-live-tv/components/sport-live-tv-alert-icon.vue';
import SportLiveTvButton from '@/sport-live-tv/components/sport-live-tv-button.vue';
import SportLiveTvState from '@/sport-live-tv/components/sport-live-tv-state.vue';
import { useSportLiveTvTranslation } from '@/sport-live-tv/composables/use-sport-live-tv-translation';

const emit = defineEmits(['retry']);

const { t } = useSportLiveTvTranslation();
</script>

<template>
  <SportLiveTvState :title="t('errorTitle')" :message="t('errorMessage')">
    <template #icon>
      <SportLiveTvAlertIcon />
    </template>
    <SportLiveTvButton :label="t('tryAgain')" @click="emit('retry')" />
  </SportLiveTvState>
</template>
